var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9391 8.09759L24.6826 18.3541C24.4391 19.0845 23.8 19.5715 23.0391 19.5715H10.4696C9.73913 19.5715 9.03913 19.115 8.79566 18.4454L3.98696 5.5715H1.2174C0.54783 5.5715 3.8147e-06 5.02368 3.8147e-06 4.35411C3.8147e-06 3.68454 0.54783 3.13672 1.2174 3.13672H4.83913C5.35653 3.13672 5.81305 3.4715 5.99566 3.95846L10.9565 17.1367H22.5217L25.1087 8.91933V7.54976V6.48454H26.7826C27.1783 6.48454 27.5435 6.69759 27.7565 7.00194C28 7.30628 28.0609 7.73237 27.9391 8.09759ZM11.0783 21.1845C10.5609 21.1845 10.0435 21.3976 9.67826 21.7628C9.31305 22.128 9.1 22.6454 9.1 23.1628C9.1 23.6802 9.31305 24.1976 9.67826 24.5628C10.0435 24.928 10.5609 25.1411 11.0783 25.1411C11.5957 25.1411 12.113 24.928 12.4783 24.5628C12.8435 24.1976 13.0565 23.6802 13.0565 23.1628C13.0565 22.6454 12.8435 22.128 12.4783 21.7628C12.113 21.3976 11.5957 21.1845 11.0783 21.1845ZM22.0044 21.1845C21.487 21.1845 20.9696 21.3976 20.6043 21.7628C20.2391 22.128 20.0261 22.6454 20.0261 23.1628C20.0261 23.6802 20.2391 24.1976 20.6043 24.5628C20.9696 24.928 21.487 25.1411 22.0044 25.1411C22.5217 25.1411 23.0391 24.928 23.4044 24.5628C23.7696 24.1976 23.9826 23.6802 23.9826 23.1628C23.9826 22.6454 23.7696 22.128 23.4044 21.7628C23.0391 21.3976 22.5217 21.1845 22.0044 21.1845Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.dd9efb8d8385e9c02a30e2f3400c31a5.svg";
export { ForwardRef as ReactComponent };